import React from 'react';
import PropTypes from 'prop-types';
import SidebarLink from './SidebarLink';
import SidebarCategory from './SidebarCategory';
import { useEffect } from 'react';
import Profile from './PndUserProfile';
import { ITC_ADMIN_ROLE_ID, CLIENT_ADMIN, HUB_MANAGER_ROLE_ID, MERCHANT_ROLE_ID, HUB_OPERATOR_ROLE_ID, SECURITY_ROLE_ID } from '../../../utils/pnd/PndConstants';
import PndRestApi from 'src/utils/pnd/PndRestApi';
import {
  Domain,
  AccessTime,
  DriveEta,
  LocalOffer,
  DirectionsCar,
  Map,
  Store,
  Group,
  Receipt,
  History,
  Description,
} from '@mui/icons-material';
import { useSelector } from 'react-redux';

const SidebarContent = ({
  onClick, sidebarCollapse,
}) => {
  debugger;
  const orderPreferences = useSelector(state => state.orderPreferences);
  const userType = localStorage.getItem("uri");
  useEffect(() => {
    // getMenuAccess();

  }, []);
  const logout = async () => {
    try {

      const response = await PndRestApi.Logout();
      if (response.status === 200 && response.data.status === 200) {
        //if(userType==MERCHANT_ROLE_ID){
        //localStorage.clear();
        localStorage.removeItem("_grecaptcha");
        localStorage.removeItem("uri");
        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");
        localStorage.removeItem("clientName");
        localStorage.removeItem("subscriptionEndDateInDays");
        localStorage.removeItem("theme-ui-color-mode");
        localStorage.removeItem("ui");
        localStorage.removeItem("ut");
        // }
        //localStorage.clear();
        sessionStorage.clear();
        // }

        window.location.reload();
      }
    } catch (error) {
      console.error('Error fetching data:', error);

    }
  };
  return (
    <div className="sidebar__content">
      <ul className="sidebar__block">
        <Profile />
      </ul>
      {userType == ITC_ADMIN_ROLE_ID &&
        <>
          <ul className="sidebar__block">
            <SidebarLink title="Dashboard" icon="chart-bars" route="/web_app/dashboard/pnd_default_dashboard" onClick={onClick} />
          </ul>
          <ul className="sidebar__block">
            <SidebarLink icon="dice" title="Client Config" route="/web_app/pnd_establishment/view" onClick={onClick} />
          </ul>
          <ul className="sidebar__block">
            <SidebarLink icon="user" title="Account Management" route="/web_app/user_management/create_user/view" onClick={onClick} />
          </ul>
          <ul className="sidebar__block">
            <SidebarLink icon="smartphone" title="Order Preference" route="/web_app/order/preference_settings" onClick={onClick} />
          </ul>
          <ul className="sidebar__block">
            <SidebarLink icon="smartphone" title="Device License Details" route="/web_app/pnd_mobile_device_key/view" onClick={onClick} />
          </ul>
          <ul className="sidebar__block">
            <SidebarLink icon="smartphone" title="Device License Log" route="/web_app/pnd_mobile_device_cancellation_log/view" onClick={onClick} />
          </ul>
          <ul className="sidebar__block">
            <SidebarLink icon="cog" title="Polling Interval Configuration" route="/web_app/itc/polling_interval" onClick={onClick} />
          </ul>

          <ul className="sidebar__block">
            <SidebarLink icon="bubble" title="FAQ" route="/web_app/itc/faq" onClick={onClick} />
          </ul>

          <ul className="sidebar__block">
            <SidebarLink icon="smartphone" title="Mobile App Release" route="/web_app/itc/mobile_app_release" onClick={onClick} />
          </ul>
        </>
      }
      {userType == CLIENT_ADMIN &&
        <>
          <ul className="sidebar__block">
            <SidebarLink title="Dashboard" icon="chart-bars" route="/web_app/dashboard/pnd_default_dashboard" onClick={onClick} />
          </ul>

          <ul className="sidebar__block">
            <SidebarCategory title="Settings" icon="dice" sidebarCollapse={sidebarCollapse}>
              <SidebarLink title="Hub" route="/web_app/pnd_hub/view" onClick={onClick} materialIcon={Domain} />
              <SidebarLink title="Hub Shift Config" route="/web_app/pnd_hub/duty_shift_confi" onClick={onClick} materialIcon={AccessTime} />
              <SidebarLink title="Leased Rider Agency" route="/web_app/driver-employer/view" onClick={onClick} materialIcon={Group} />
              <SidebarLink title="Customer DLV Tag" route="/web_app/customer_tag_settings/view" onClick={onClick} materialIcon={LocalOffer} />
              <SidebarLink title="Driver" route="/web_app/driver/view" onClick={onClick} materialIcon={DriveEta} />
              <SidebarLink title="Vehicle" route="/web_app/pnd_vehicle/view" onClick={onClick} materialIcon={DirectionsCar} />
              <SidebarLink title="Driver-Vehicle Mapping" route="/web_app/driver-vehicle/view" onClick={onClick} materialIcon={DriveEta} />

              {orderPreferences?.data?.zoneBasedDlvApplicable &&
                <SidebarLink title="Delivery Rate" route="/web_app/pnd_delivery_zone_rate/view" onClick={onClick} materialIcon={Receipt} />
              }
              {orderPreferences?.data?.merchantEnabled &&
                <>
                  <SidebarLink title="Merchant" route="/web_app/pnd_order/merchant/view" onClick={onClick} materialIcon={Store} />
                  <SidebarLink title="Territory" route="/web_app/pnd_territory/view" onClick={onClick} materialIcon={Map} />
                </>
              }
              {/* <SidebarLink title="Device License Details" route="/web_app/pnd_mobile_device_key/view" onClick={onClick} materialIcon={VpnKey} /> */}

              <SidebarLink icon="smartphone" title="Device License" route="/web_app/pnd_mobile_device_key/view" onClick={onClick} />

            </SidebarCategory>
          </ul>
          <ul className="sidebar__block">
            <SidebarCategory title="Account Management" icon="user" sidebarCollapse={sidebarCollapse}>
              <SidebarLink title="Hub Users" route="/web_app/user_management/create_user/view" onClick={onClick} />
              {orderPreferences?.data?.merchantEnabled &&
                <SidebarLink title="Merchant Users" route="/web_app/user_management/create_merchant_user/view" onClick={onClick} />
              }
            </SidebarCategory>
          </ul>

          <ul className="sidebar__block">
            <SidebarCategory title="View" icon="user" sidebarCollapse={sidebarCollapse}>
              <SidebarLink title="Subcription Details" route="/web_app/views/general/subcscription_view" onClick={onClick} />
            </SidebarCategory>
          </ul>
          {/* <ul className="sidebar__block">
            <SidebarCategory title="Rider" icon="bicycle" collapse={sidebarCollapse}>
              <SidebarLink title="Rider Transfer" route="/user_management/role/view" onClick={onClick} />

            </SidebarCategory>
          </ul> */}
          {/* <ul className="sidebar__block">
            <SidebarLink icon="select" title="Report" route="/merchant/dispute/management/home" onClick={hideSidebar} />
          </ul> */}
          {/* <ul className="sidebar__block">
            <SidebarCategory title="History" icon="history" collapse={sidebarCollapse}>
              <SidebarLink title="Order" route="/user_management/role/view" onClick={onClick} />
              <SidebarLink title="Rider" route="/user_management/role/view" onClick={onClick} />
              <SidebarLink title="Vehicle" route="/user_management/role/view" onClick={onClick} />
              <SidebarLink title="Hub Operator" route="/user_management/role/view" onClick={onClick} />
            </SidebarCategory>
          </ul> */}
          {
            userType != CLIENT_ADMIN ?
              <ul className="sidebar__block">
                <SidebarCategory title="Report" icon="exit" sidebarCollapse={sidebarCollapse} >
                  <SidebarLink title="Order Summary Report" route="/web_app/report/order_summary_report" onClick={onClick} />
                  <SidebarLink title="Order Detailed Report " route="/web_app/report/order_detailed_report" onClick={onClick} />
                  <SidebarLink title="Rider Duty Report " route="/web_app/report/duty_report" onClick={onClick} />
                  <SidebarLink title="Rider Activity Summary" route="/web_app/report/rider_activity_report" onClick={onClick} />
                </SidebarCategory>
              </ul> :
              <ul className="sidebar__block">
                <SidebarCategory title="Report" icon="exit" sidebarCollapse={sidebarCollapse} >
                  <SidebarLink title="Order Summary Report" route="/web_app/report/order_summary_report" onClick={onClick} />
                  <SidebarLink title="Order Performance Report" route="/web_app/report/order_performance_report" onClick={onClick} />
                  <SidebarLink title="Order Report" route="/web_app/report/order_report" onClick={onClick} />
                  <SidebarLink title="OTR Report" route="/web_app/report/order_otr_report" onClick={onClick} />
                  <SidebarLink title="OTR Interval Report" route="/web_app/report/order_otr_interval_report" onClick={onClick} />
                  <SidebarLink title="Complaint DLV Report" route="/web_app/report/complaint_dlv_report" onClick={onClick} />

                </SidebarCategory>
              </ul>
          }
          <ul className="sidebar__block">
            <SidebarLink title="Reset My Password" icon="exit" route="/web_app/user_management/reset_password" />
          </ul>
        </>

      }
      {
        userType == HUB_MANAGER_ROLE_ID &&

        <> <ul className="sidebar__block">
          <SidebarLink title="Dashboard" icon="chart-bars" route="/web_app/dashboard/pnd_default_dashboard" onClick={onClick} />
        </ul>
          <ul className="sidebar__block">
            <SidebarCategory title="Settings" icon="dice" sidebarCollapse={sidebarCollapse}>
              <SidebarLink title="Rider Availability" route="/web_app/rider/availability" onClick={onClick} />
              <SidebarLink title="Rider Duty Roster" route="/web_app/rider/duty_roaster/view" onClick={onClick} />
              <SidebarLink title="Rider Password Reset" route="/web_app/user_management/rider/reset_password" onClick={onClick} />
            </SidebarCategory>
          </ul>

          <ul className="sidebar__block">
            <SidebarCategory title="Order Management" icon="gift" sidebarCollapse={sidebarCollapse}>
              <SidebarLink title="Pick Up /Drop Off" route="/web_app/pnd_order/order_details" onClick={onClick} />

              {orderPreferences?.data?.merchantEnabled &&
                <SidebarLink title="Order Return" route="/web_app/order/return" onClick={onClick} />
              }
              {orderPreferences?.data?.orderCancelEnabled &&
                <SidebarLink title="Order Cancellation" route="/web_app/pnd_order_cancel/order_details" onClick={onClick} />
              }
              <SidebarLink title="Order Transfer" route="/web_app/pnd_order/order_transfer/view" onClick={onClick} />
              <SidebarLink title="Order Reassignment" route="/web_app/pnd_order/order_reassign/view" onClick={onClick} />
              <SidebarLink title="Order Unassignment" route="/web_app/order/unassign" onClick={onClick} />
              <SidebarLink title="Order Reschedule" route="/web_app/pnd_order/order-reschedule" onClick={onClick} />
            </SidebarCategory>
          </ul>
          <ul className="sidebar__block">
            <SidebarCategory title="Order View" icon="dice" sidebarCollapse={sidebarCollapse}>
              <SidebarLink title="Punched Order" route="/web_app/views/order/punched_order_view" onClick={onClick} />
              <SidebarLink title="Cancelled Orders" route="/web_app/views/order/cancelled_order_view" onClick={onClick} />
            </SidebarCategory>
          </ul>
          <ul className="sidebar__block">
            <SidebarCategory title="General View" icon="dice" sidebarCollapse={sidebarCollapse}>
              <SidebarLink title="Hub" route="/web_app/views/hub_view" onClick={onClick} />
              <SidebarLink title="Hub Operators" route="/web_app/views/hub_operators/view" onClick={onClick} />
              <SidebarLink title="Leased Rider Agency" route="/web_app/views/driver_employer_view" onClick={onClick} />
              {orderPreferences?.data?.merchantEnabled &&
                <SidebarLink title="Merchant" route="/web_app/views/general/merchant_view" onClick={onClick} />
              }
              <SidebarLink title="Rider" route="/web_app/views/rider_view" onClick={onClick} />
              <SidebarLink title="Rider Live Map" route="/web_app/rider/live_map" onClick={onClick} />
              <SidebarLink title="Vehicle" route="/web_app/views/vehicle_view" onClick={onClick} />

            </SidebarCategory>
          </ul>

          <ul className="sidebar__block">
            <SidebarCategory title="History" icon="history" sidebarCollapse={sidebarCollapse}>
              <SidebarLink title="Order" route="/web_app/order/order_history" onClick={onClick} />
              <SidebarLink title="Rider Location" route="/web_app/rider/location_history" onClick={onClick} />
              <SidebarLink title="Duty Roster" route="/web_app/rider/roaster_history" onClick={onClick} />
              <SidebarLink title="Rider Trip" route="/web_app/rider/trip_history" onClick={onClick} />
              <SidebarLink title="Security Approval" route="/web_app/security/history" onClick={onClick} />

              {/* <SidebarLink title="Rider" route="/user_management/role/view" onClick={onClick} />
              <SidebarLink title="Vehicle" route="/web_app/pnd_vehicle/view" onClick={onClick} /> */}
              {/* <SidebarLink title="Hub Operator" route="/web-app/views/hub_operators/view" onClick={onClick} /> */}
            </SidebarCategory>
          </ul>
          <ul className="sidebar__block">
            <SidebarCategory title="Report" icon="exit" sidebarCollapse={sidebarCollapse} >
              <SidebarLink title="Order Summary Report" route="/web_app/report/order_summary_report" onClick={onClick} />
              <SidebarLink title="Order Detailed Report " route="/web_app/report/order_detailed_report" onClick={onClick} />
              <SidebarLink title="Order Failed Report" route="/web_app/report/order_failed_report" onClick={onClick} />
              <SidebarLink title="Rider Duty Report " route="/web_app/report/duty_report" onClick={onClick} />
              <SidebarLink title="Rider Activity Summary" route="/web_app/report/rider_activity_report" onClick={onClick} />
              <SidebarLink title="Security Approval Report" route="/web_app/security/report" onClick={onClick} />
              <SidebarLink title="Complaint DLV Report" route="/web_app/report/complaint_dlv_report" onClick={onClick} />

            </SidebarCategory>
          </ul>
          <ul className="sidebar__block">
            <SidebarLink title="Chat" icon="bubble" route="/web_app/chat" onClick={onClick} />
          </ul>
        </>}

      {userType == HUB_OPERATOR_ROLE_ID &&
        <>
          <ul className="sidebar__block">
            <SidebarLink title="Dashboard" icon="chart-bars" route="/web_app/dashboard/pnd_default_dashboard" onClick={onClick} />
          </ul>
          {orderPreferences?.data?.merchantEnabled &&
            <ul className="sidebar__block">
              <SidebarCategory title="Customer Operation" icon="dice" sidebarCollapse={sidebarCollapse}>
                <SidebarLink title="Customers" route="/web_app/pnd_customer/customer/view" onClick={onClick} />
                <SidebarLink title="Addressbook" route="/web_app/pnd_customer/customer_address_book/view" onClick={onClick} />
                {/* <SidebarLink title="Pick Up Point" route="/web_app/hub_pick_up_point/view" onClick={onClick} /> */}
              </SidebarCategory>
            </ul>
          }
          <ul className="sidebar__block">
            <SidebarCategory title="Order Management" icon="gift" sidebarCollapse={sidebarCollapse}>
              <SidebarLink title="Order Punching" route="/web_app/pnd_order/order_details" onClick={onClick} />
              {orderPreferences?.data?.merchantEnabled &&
                <SidebarLink title="Order Return" route="/web_app/order/return" onClick={onClick} />
              }

            </SidebarCategory>
          </ul>
          <ul className="sidebar__block">
            <SidebarCategory title="History" icon="dice" sidebarCollapse={sidebarCollapse}>
              <SidebarLink title="Order" route="/web_app/order/order_history" onClick={onClick} />
              <SidebarLink title="Duty Roster" route="/web_app/rider/roaster_history" onClick={onClick} />
              <SidebarLink title="Rider Location" route="/web_app/rider/location_history" onClick={onClick} />
              <SidebarLink title="Rider Trip" route="/web_app/rider/trip_history" onClick={onClick} />
            </SidebarCategory>
          </ul>

          <ul className="sidebar__block">
            <SidebarCategory title="View" icon="dice" sidebarCollapse={sidebarCollapse}>
              <SidebarLink title="Punched Order" route="/web_app/views/order/punched_order_view" onClick={onClick} />
              <SidebarLink title="Rider" route="/web_app/views/rider_view" onClick={onClick} />
              <SidebarLink title="Rider Live Map" route="/web_app/rider/live_map" onClick={onClick} />
              <SidebarLink title="Vehicle" route="/web_app/views/vehicle_view" onClick={onClick} />
              <SidebarLink title="Cancelled Orders" route="/web_app/views/order/cancelled_order_view" onClick={onClick} />
            </SidebarCategory>
          </ul>

          <ul className="sidebar__block">
            <SidebarLink title="Chat" icon="bubble" route="/web_app/chat" onClick={onClick} />
          </ul>

        </>}{userType == MERCHANT_ROLE_ID &&
          <>
            <ul className="sidebar__block">
              <SidebarLink title="Dashboard" icon="chart-bars" route="/web_app/dashboard/pnd_default_dashboard" onClick={onClick} />
            </ul>
            <ul className="sidebar__block">
              <SidebarCategory title="Settings" icon="dice" sidebarCollapse={sidebarCollapse}>
                <SidebarLink title="Customer" route="/web_app/pnd_merchant/customer/view" onClick={onClick} />
                <SidebarLink title="Customer Address Book" route="/web_app/pnd_merchant/customer_addres_book/view" onClick={onClick} />
                <SidebarLink title="Pick Up Point" route="/web_app/pnd_pick_up_point/view" onClick={onClick} />
              </SidebarCategory>
            </ul>
            <ul className="sidebar__block">
              <SidebarCategory title="Order Management" icon="gift" sidebarCollapse={sidebarCollapse}>
                <SidebarLink title="Order Punching" route="/web_app/pnd_order/order_details" onClick={onClick} />
                {orderPreferences?.data?.orderCancelEnabled &&
                  <SidebarLink title="Order Cancellation" route="/web_app/pnd_order_cancel/order_details" onClick={onClick} />
                }
                <SidebarLink title="Order Recall" route="/web_app/pnd_order/merchant/order_recall" onClick={onClick} />
                {/* <SidebarLink title="Change Sequence" route="/user_management/menu/view" onClick={onClick} />
                <SidebarLink title="Transfer Order" route="/web_app/pnd_order/order_transfer/view" onClick={onClick} /> */}
              </SidebarCategory>
            </ul>
            <ul className="sidebar__block">
              <SidebarCategory title="View" icon="dice" sidebarCollapse={sidebarCollapse}>
                <SidebarLink title="Pick Up Orders" route="/web_app/views/order/punched_order_view" onClick={onClick} />
                <SidebarLink title="Cancelled Orders" route="/web_app/views/order/cancelled_order_view" onClick={onClick} />
                <SidebarLink title="Withdrew Orders" route="/web_app/views/order/withdrew_order_view" onClick={onClick} />
              </SidebarCategory>
            </ul>
          </>
      }
      {userType == SECURITY_ROLE_ID &&
        <>
          <ul className="sidebar__block">
            <SidebarLink title="Dashboard" icon="chart-bars" route="/web_app/dashboard/pnd_default_dashboard" onClick={onClick} />
            <SidebarLink title="Order Management" icon="chart-bars" route="/web_app/order/security_approval" onClick={onClick} />
            <SidebarLink title="History" route="/web_app/security/history" onClick={onClick} materialIcon={History} />

          </ul>
        </>
      }
      {userType != ITC_ADMIN_ROLE_ID &&
        <ul className="sidebar__block">
          <SidebarLink title="FAQ" icon="chart-bars" route="/web_app/faq/view" onClick={onClick} />
        </ul>
      }
      <ul className="sidebar__block">
        <SidebarLink title="Support" materialIcon={Description} route="/web_app/user_manual/view" onClick={onClick} />
      </ul>
      <ul className="sidebar__block">
        <SidebarLink title="Log Out" icon="exit" onClick={() => { logout(); onClick(); }} route='/landing_app' />
      </ul>
    </div>
  );
};

SidebarContent.propTypes = {
  changeToDark: PropTypes.func.isRequired,
  changeToLight: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  sidebarCollapse: PropTypes.bool,
};

export default SidebarContent;